import React from 'react'
import { Link } from 'react-router-dom'
import TrialLock from '../components/TrialLock'
import '../styles/ComingSoon.scss'

const ComingSoon: React.FC = () => {
    return (
        <main className="recovery-page" aria-labelledby="coming-soon-title">
            <section className="recovery-card">
                <p className="recovery-eyebrow">Not available yet</p>
                <h1 id="coming-soon-title">This feature is coming soon</h1>
                <p className="recovery-message">
                    It is not available in the console yet. You can return to the dashboard or explore resources that are ready now.
                </p>
                <div className="recovery-actions">
                    <Link className="recovery-action recovery-action--primary" to="/">
                        Go to dashboard
                    </Link>
                    <TrialLock locked={false} paidResource><Link className="recovery-action" to="/deploy">
                        Explore resources
                    </Link></TrialLock>
                </div>
            </section>
        </main>
    )
}

export default ComingSoon
